var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebzLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 52,
    viewBox: "0 0 77 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.077 0V28.4521C64.077 36.6242 59.8549 39.9507 54.0184 39.9507C48.2929 39.9507 43.9602 36.5245 43.9602 28.4521V0H31.989V28.4521C31.989 36.5245 27.7661 39.9507 22.041 39.9507C16.3812 39.9507 12.2361 36.824 11.9935 29.1732C10.3128 30.4151 8.24632 31.1469 6.01331 31.1469C3.76913 31.1469 1.7026 30.4151 0.0223567 29.1624C0.287341 44.2978 9.24087 51.1503 20.8361 51.1503C28.3743 51.1503 34.4096 48.0236 37.9249 42.3793H38.1349C41.7496 48.0231 47.7844 51.1503 55.2237 51.1503C66.9957 51.1503 76.0486 44.0872 76.0486 28.4529V0H64.077ZM11.9819 12.9287V0H0.0107422V12.9511C1.69098 11.698 3.76869 10.9554 6.01288 10.9554C8.24589 10.9549 10.3124 11.6868 11.9819 12.9287Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6614 21.0452C11.6614 24.1719 9.13029 26.7114 6.01329 26.7114C2.89586 26.7114 0.364746 24.1724 0.364746 21.0452C0.364746 17.918 2.89586 15.3901 6.01329 15.3901C9.12986 15.3906 11.6614 17.9184 11.6614 21.0452Z",
    fill: "#FC9F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebzLogo);
export default __webpack_public_path__ + "static/media/webz-logo.de59876f1eca12b48fed0770bc56370a.svg";
export { ForwardRef as ReactComponent };